"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputIconComponent = exports.flexAdornment = exports.inputDisabled = exports.inputWarning = exports.inputError = exports.inputSuccess = exports.inputFocus = exports.inputBase = exports.inputWrap = void 0;

var _stylitas = require("@creditas/stylitas");

const inputWrap = () => (0, _stylitas.css)`
  position: relative;
`;

exports.inputWrap = inputWrap;
const inputIconComponent = (0, _stylitas.css)`
  pointer-events: none;
`;
exports.inputIconComponent = inputIconComponent;

const inputFocus = ({
  theme
}) => (0, _stylitas.css)`
  border-width: 2px;
  border-color: ${theme.bColorsecondary05};
`;

exports.inputFocus = inputFocus;

const inputSuccess = ({
  theme
}) => (0, _stylitas.css)`
  border-color: ${theme.bColorsuccess};
`;

exports.inputSuccess = inputSuccess;

const inputError = ({
  theme
}) => (0, _stylitas.css)`
  border-color: ${theme.bColordanger};
`;

exports.inputError = inputError;

const inputWarning = ({
  theme
}) => (0, _stylitas.css)`
  border-color: ${theme.bColorwarning};
`;

exports.inputWarning = inputWarning;

const inputDisabled = ({
  theme
}) => (0, _stylitas.css)`
  color: ${theme.bColorneutral05};
  border-color: ${theme.bColorneutral04};
`;

exports.inputDisabled = inputDisabled;

const inputBase = ({
  inputPaddingLeft,
  success,
  error,
  warning,
  ...props
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.paragraph(props.theme)}
  width: 100%;
  background: transparent;
  margin: 0;
  padding: 8px 0 8px 0;
  border: none;
  border-bottom: 1px solid ${props.theme.bColorneutral05};
  box-sizing: border-box;
  -webkit-appearance: none;
  outline: none;
  ::placeholder {
    color: ${props.theme.bColorneutral05};
  }

  ${success && inputSuccess(props)};
  ${warning && inputWarning(props)};
  ${error && inputError(props)};

  &:focus {
    ${inputFocus(props)};
  }

  &:disabled {
    ${inputDisabled(props)};
  }
`;

exports.inputBase = inputBase;

const flexAdornment = ({
  position
}) => (0, _stylitas.css)`
  position: absolute;
  top: 0;
  ${position === 'start' ? 'left:0;' : 'right:0;'}
  display: flex;
  height: 100%;
  align-items: center;
  pointer-events: none;
`;

exports.flexAdornment = flexAdornment;